<template>
  <div class="card" id="dsObject2D">
    <nav class="fixed-bar navbar navbar-expand-lg navbar-light" color="white">
      <h3 class="navbar-brand">DS-Object 2D</h3>
      <add-ds-object
        @save="saveSetDesign"
        @open="openDialog"
        @close="closeDialog"
        v-bind:dialog="dialog"
        v-bind:info="editedItem"
        v-bind:edited-i-d="editedID">
      </add-ds-object>
    </nav>
    <hr/>
    <div class="container fluid grid-list-lg">
      <asset-table
        v-bind:updated="updated"
        v-bind:asset_type="asset_type"
        @edit="editItem"
        v-bind:headers="headers">
      </asset-table>
    </div>
  </div>
</template>

<script>
import { db } from '../../firebaseDB'
import AssetTable from './assetTable'
import _ from 'lodash'
import AddDsObject from './add-new/addDsObject.vue'

export default {
  name: 'basic_character_action',
  components: { AssetTable, AddDsObject },
  data: () => ({
    asset_type: 'object2D',
    headers: [
      {th: 'Name', name: 'name'},
      {th: 'Date Uploaded', name: 'date_uploaded'},
      // {th: 'Date Modified', name: 'date_modified'},
      {th: 'Uploaded By', name: 'creator'},
      {th: 'Text', name: 'text'}
    ],
    dialog: '',
    updated: false,
    editedItem: {
      name: '',
      mediaType: '',
      startTime: 0,
      endTime: 0,
      duration: 0,
      typeOfDisplay: '',
      mediaHeight: '',
      mediaWidth: '',
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      scaleOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      offsetHorizontal: '',
      offsetVertical: ''
    },
    defaultItem: {
      name: '',
      mediaType: '',
      startTime: 0,
      endTime: 0,
      duration: 0,
      typeOfDisplay: '',
      mediaHeight: '',
      mediaWidth: '',
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      scaleOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      offsetHorizontal: '',
      offsetVertical: ''
    },
    editedID: -1,
    editedIndex: -1,
    tableData: []
  }),
  methods: {
    saveSetDesign (updatedData) {
      setTimeout(() => {
        let updates = {}
        let requireDefaultUpdate = true

        this.updateMetaData(updatedData, updates)
        console.log(updatedData.id)

        updates[`asset_data/${this.asset_type}/${updatedData.id}/name`] = updatedData.name || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/mediaType`] = updatedData.mediaType || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/startTime`] = updatedData.startTime || 0
        updates[`asset_data/${this.asset_type}/${updatedData.id}/endTime`] = updatedData.endTime || 0
        updates[`asset_data/${this.asset_type}/${updatedData.id}/duration`] = updatedData.duration || 0
        updates[`asset_data/${this.asset_type}/${updatedData.id}/typeOfDisplay`] = updatedData.typeOfDisplay || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/mediaHeight`] = updatedData.mediaHeight || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/mediaWidth`] = updatedData.mediaWidth || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/rotationOfOrigin`] = {
          X: updatedData.rotationOfOrigin.X || '0',
          Y: updatedData.rotationOfOrigin.Y || '0',
          Z: updatedData.rotationOfOrigin.Z || '0'
        }
        updates[`asset_data/${this.asset_type}/${updatedData.id}/positionOfOrigin`] = {
          X: updatedData.positionOfOrigin.X || '0',
          Y: updatedData.positionOfOrigin.Y || '0',
          Z: updatedData.positionOfOrigin.Z || '0'
        }
        updates[`asset_data/${this.asset_type}/${updatedData.id}/scaleOfOrigin`] = {
          X: updatedData.scaleOfOrigin.X || '0',
          Y: updatedData.scaleOfOrigin.Y || '0',
          Z: updatedData.scaleOfOrigin.Z || '0'
        }
        updates[`asset_data/${this.asset_type}/${updatedData.id}/offsetHorizontal`] = updatedData.offsetHorizontal || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/offsetVertical`] = updatedData.offsetVertical || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/componentType`] = updatedData.componentType || ''

        if (requireDefaultUpdate) {
          db.ref('assets').update(updates).then(snapshot => {
            this.closeDialog()
            this.updated = true
          })
        }
      }, 2000)
      this.updated = false
    },
    getDatetime () {
      const currentdate = new Date()
      return currentdate.getDate() + '/' +
        (currentdate.getMonth() + 1) + '/' +
        currentdate.getFullYear() + ' @ ' +
        currentdate.getHours() + ':' +
        currentdate.getMinutes() + ':' +
        currentdate.getSeconds()
    },
    updateMetaData (updatedData, updates) {
      const datetime = this.getDatetime()
      if (!updatedData.id) {
        updatedData.id = db.ref(`asset_data/${this.asset_type}/`).push().key
        updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/creator`] = this.$store.state.user.email
        updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_uploaded`] = datetime
      }
      updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_modified`] = datetime
    },
    shouldUpload (fileType, updatedData) {
      if (fileType === this.fileType.image) {
        return updatedData.image && updatedData.image.imageFile
      } else if (fileType === this.fileType.fbx) {
        return updatedData.fbx && updatedData.fbx.file
      } else if (fileType === this.fileType.asset_bundle) {
        return (updatedData.asset_bundle.iOS && updatedData.asset_bundle.iOS.file) ||
          (updatedData.asset_bundle.Android && updatedData.asset_bundle.Android.file)
      } else {
        return false
      }
    },
    openDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.editedID = -1
      this.editedIndex = -1
      this.editedItem = _.cloneDeep(this.defaultItem)
      this.dialog = false
    },
    editItem (item) {
      this.editedIndex = item.index
      this.editedID = item.id
      this.editedItem = item.item
      if (!this.editedItem.hasOwnProperty('positionOfOrigin')) {
        this.editedItem.positionOfOrigin = {
          X: 0,
          Y: 0,
          Z: 0
        }
      }
      if (!this.editedItem.hasOwnProperty('rotationOfOrigin')) {
        this.editedItem.rotationOfOrigin = {
          X: 0,
          Y: 0,
          Z: 0
        }
      }
      if (!this.editedItem.hasOwnProperty('scaleOfOrigin')) {
        this.editedItem.scaleOfOrigin = {
          X: 0,
          Y: 0,
          Z: 0
        }
      }
      this.dialog = true
    }
  }
}
</script>

<style scoped>
#visualEffect {
scroll-margin: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/assets/dsObject2D.vue